<!-- mobile drawer backdrop -->
<div class="sidenav-backdrop" *ngIf="mobileOpen" (click)="closeMobile()"></div>

<div
  class="sidenav"
  [ngClass]="collapsed ? 'sidenav-collapsed' : ''"
  [class.mobile-open]="mobileOpen"
>
  <!-- mobile-only drawer header: aquila logo + close -->
  <div class="mobile-drawer-header">
    <img
      src="assets/images/new-images/logo-2.png"
      class="mobile-drawer-logo"
      routerLink="/dashboard"
      (click)="closeMobile()"
    />
    <button
      class="mobile-drawer-close"
      (click)="closeMobile()"
      aria-label="Close menu"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="logo-container flex justify-between items-center">
    <img
      *ngIf="collapsed"
      src="assets/images/new-images/logo-2.png"
      class="header-image"
      routerLink="/dashboard"
    />
    <button *ngIf="!collapsed" class="logo" (click)="toggleCollapse()">
      <i class="fas fa-chevron-right close-icon"></i>
    </button>
    <button class="btn-close" *ngIf="collapsed" (click)="closeNav()">
      <i class="fas fa-chevron-left close-icon"></i>
    </button>
  </div>

  <ul class="sidenav-nav">
    <li
      class="sidenav-nav-item flex items-center gap-3"
      *ngFor="let menu of menus"
    >
      <ng-container *hasPermissions="menu.perm">
        <div class="hidden md:block w-[10px]">
          <svg
            class="text-primary"
            *ngIf="menu.link === activeLink && collapsed"
            width="10"
            height="40"
            viewBox="0 0 10 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 0H3C6.86599 0 10 3.13401 10 7V43C10 46.866 6.86599 50 3 50H0V0Z"
              fill="currentcolor"
            />
          </svg>
        </div>
        <a
          *ngIf="menu.link !== 'logout'"
          href=""
          [routerLink]="menu.link"
          (click)="closeMobile()"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngClass]="
            menu.link === activeLink
              ? '!bg-primary !text-white active'
              : 'bg-white text-primary'
          "
          class="flex items-center gap-[5px] w-[100%] rounded-lg sidenav-nav-link"
        >
          <!-- <img [matTooltip]="menu.label" [matTooltipClass]="'bg-dark_white !text-primary text-lg p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'" class="sidenav-link-icon" [ngClass]="menu.link === activeLink ? 'filter-white' : ''" [src]="menu.icon" alt=""> -->
          <!-- <span [matTooltip]="menu.label" [matTooltipClass]="'bg-dark_white !text-primary text-lg p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'" class="sidenav-link-icon" [innerHTML]="renderIcon(menu.icon)"></span> -->
          <mat-icon
            [matTooltip]="menu.label"
            [matTooltipClass]="
              'bg-dark_white !text-primary p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'
            "
            class="sidenav-link-icon"
            [svgIcon]="menu.icon"
          ></mat-icon>

          <div
            class="sidenav-link-text sidebar-text flex-1"
            [ngClass]="!collapsed ? 'hidden' : ''"
          >
            {{ menu.label }}
          </div>
          <span
            *ngIf="collapsed && badgeCounts[menu.link] > 0"
            class="mr-2 min-w-[20px] h-5 rounded-full text-[8px] font-light flex items-center justify-center px-1.5"
            [ngClass]="
              menu.link === activeLink ? 'bg-white' : 'bg-primary text-white'
            "
            [style.color]="menu.link === activeLink ? '#BD2B47' : ''"
          >
            {{ badgeCounts[menu.link] > 99 ? "99+" : badgeCounts[menu.link] }}
          </span>
        </a>
        <!-- logout -->
        <a
          *ngIf="menu.link === 'logout'"
          (click)="logout()"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngClass]="
            menu.link === activeLink
              ? '!bg-primary !text-white active'
              : 'bg-white text-primary'
          "
          class="flex items-center gap-[5px] w-[100%] rounded-lg sidenav-nav-link"
        >
          <!-- <img [matTooltip]="menu.label" [matTooltipClass]="'bg-dark_white !text-primary text-lg p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'" class="sidenav-link-icon" [ngClass]="menu.link === activeLink ? 'filter-white' : ''" [src]="menu.icon" alt=""> -->
          <!-- <span [matTooltip]="menu.label" [matTooltipClass]="'bg-dark_white !text-primary text-lg p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'" class="sidenav-link-icon" [innerHTML]="renderIcon(menu.icon)"></span> -->
          <mat-icon
            [matTooltip]="menu.label"
            [matTooltipClass]="
              'bg-dark_white !text-primary p-3 pl-10 px-8 !-mt-[2.3em] !ml-[4em]'
            "
            class="sidenav-link-icon"
            [svgIcon]="menu.icon"
          ></mat-icon>

          <div
            class="sidenav-link-text sidebar-text"
            [ngClass]="!collapsed ? 'hidden' : ''"
          >
            {{ menu.label }}
          </div>
        </a>
      </ng-container>
    </li>
  </ul>
</div>
